import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'
import { scenarioQueryKeys } from '../queryKeys'

import { buildSingularResourcefulRequests } from '@utils/requests'

export function useScenarioQuery({
  scenarioID,
  initialData,
  queryKey,
}) {
  const basePath = `/api/scenarios/${scenarioID}`
  const scenarioRequests = buildSingularResourcefulRequests(basePath)
  const queryClient = useQueryClient()

  const scenarioQuery = useQuery({
    queryFn: scenarioRequests.show,
    queryKey,
    initialData
  })

  const updateScenarioMutation = useMutation({
    mutationFn: scenarioRequests.update,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [scenarioQueryKeys(scenarioID).scenario]
      })
    }

  })

  const updateScenarioWithForecastInvalidationMutation = useMutation({
    mutationFn: scenarioRequests.update,
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: [scenarioQueryKeys(scenarioID).scenario]
      })
      await queryClient.invalidateQueries({
        queryKey: [scenarioQueryKeys(scenarioID).forecasts]
      })
      queryClient.invalidateQueries({
        queryKey: [scenarioQueryKeys(scenarioID).assets]
      })
      queryClient.invalidateQueries({
        queryKey: [scenarioQueryKeys(scenarioID).riskProfile]
      })
    }
  })


  const isFetching = scenarioQuery.isFetching

  const isAnyLoading = scenarioQuery.isFetching ||
    updateScenarioMutation.isLoading ||
    updateScenarioWithForecastInvalidationMutation.isLoading

  return {
    data: scenarioQuery.data,
    actions: {
      update: updateScenarioMutation.mutateAsync,
      updateWithForecastInvalidation: updateScenarioWithForecastInvalidationMutation.mutateAsync
    },
    status: scenarioQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
